import { extractApiErrorMessage } from "../../utils/util";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value: string) => EMAIL_RE.test(value.trim());

const pad = (n: number) => String(n).padStart(2, "0");

// <input type="date"> works in local "YYYY-MM-DD".
export const toDateInputValue = (ms: number) => {
  const d = new Date(ms);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// Local noon, so the stored day never shifts across time zones.
export const fromDateInputValue = (value: string): number | undefined => {
  const [y, m, d] = value.split("-").map(Number);
  if (!y || !m || !d) return undefined;
  return new Date(y, m - 1, d, 12).getTime();
};

export const formatDate = (ms: number | null | undefined) =>
  ms ? new Date(ms).toLocaleDateString() : "—";

export const errorMessage = (error: unknown, fallback: string) =>
  extractApiErrorMessage(error, fallback);
